import React from "react";

/**
 * Single stat tile on the dashboard.
 * Props:
 *   label  {string}
 *   count  {number}
 *   icon   {ReactNode}
 */
const StatCard = ({ label, count, icon }) => (
  <div
    style={{
      background: "white",
      borderRadius: "12px",
      padding: "20px 22px",
      flex: 1,
      minWidth: "120px",
      boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  >
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <span style={{ fontSize: "13px", color: "#888" }}>{label}</span>
      <div
        style={{
          background: "#f0f5ff",
          borderRadius: "8px",
          padding: "7px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </div>
    </div>
    <div style={{ fontSize: "32px", fontWeight: "800", color: "#111", lineHeight: 1 }}>
      {count}
    </div>
  </div>
);

export default StatCard;
